import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetFixedAssetResponse } from '@/api/handlers/resources/fixedAssets/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { FixedAssetQueryKeys } from './fixedAssetQueryKeys';

/**
 * One asset with its depreciation schedule and the entries that touched it.
 * Disabled while the drawer is closed (`assetId === null`).
 */
export const useFixedAssetQuery = (assetId: string | null) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetFixedAssetResponse>>({
        queryKey: FixedAssetQueryKeys.detail(assetId ?? 'none'),
        queryFn: () => apiClient.fixedAssets.getAsset(assetId as string),
        enabled: assetId !== null,
    });
};
